import { useTranslation } from 'react-i18next'

import styles from '../../ReassignDonationModal.module.scss'

import { AddDonationToReassignmentQueueFormProps } from './addDonationToReassignmentQueueForm.types'
import { AsyncSelect, FormField, Select, Text, TextInput } from '@percent/lemonade'

export function AddDonationToReassignmentQueueForm({
  onOrganisationChange,
  onReassignedReasonChange,
  onQueryChange,
  values,
  touched,
  errors,
  isOrganisationsQueryLoading,
  query,
  searchResults,
  reassignedReasonOptions,
  onCustomReasonChange,
  onCustomReasonBlur,
  reasons
}: AddDonationToReassignmentQueueFormProps) {
  const { t } = useTranslation()

  return (
    <form>
      <div className={styles.withFieldGap}>
        <Text size="small" fontWeight="bold" dataTestId="typeOfReassignmentLabel">
          {t('dialog.reassignDonation.typeOfReassignment.alert.title')}:{' '}
        </Text>
        <Text size="small" dataTestId="typeOfReassignmentValue">
          {t('typography.reassignmentKind.unpayable')}
        </Text>
      </div>
      <div className={styles.withFieldGap}>
        <FormField label={t('typography.newOrganisation')} data-testid="organisationId" necessity="optional">
          <AsyncSelect
            name="organisationId"
            placeholder={t('typography.search.organisation')}
            onChange={e => {
              onOrganisationChange(e?.value || '', e?.label || '')
            }}
            options={searchResults}
            setQuery={e => {
              onQueryChange(e)
            }}
            query={query}
            loading={isOrganisationsQueryLoading}
            loadingText="loading"
            noResultsFoundText={t('errorMessage.noResult')}
            data-testid="organisationSearch"
            defaultValue={searchResults.find(option => option.value === values.organisationId)}
          />
        </FormField>
      </div>
      <div className={styles.withFieldGap}>
        <FormField
          label={t('dialog.reassignDonation.reassignedReason')}
          data-testid="reassignedReason"
          necessity="required"
        >
          <Select
            data-testid="reassignedReasonSelect"
            placeholder={t('dialog.reassignDonation.reassignedReason')}
            options={reassignedReasonOptions}
            defaultValue={reassignedReasonOptions.find(option => option.value === values.reassignedReason)}
            onChange={({ value }) => onReassignedReasonChange(value)}
          />
        </FormField>
      </div>
      {values.reassignedReason === reasons.other && (
        <FormField
          label={t('dialog.reassignDonation.customReason')}
          necessity="required"
          status={touched.customReason && errors.customReason ? 'danger' : 'default'}
          statusMessage={errors.customReason || ''}
          data-testid="customReason"
        >
          <TextInput
            name="customReason"
            value={values.customReason || ''}
            placeholder={t('dialog.reassignDonation.customReason')}
            onBlur={onCustomReasonBlur}
            onChange={onCustomReasonChange}
          />
        </FormField>
      )}
    </form>
  )
}
